import React from 'react'
import BaseIcon from './BaseIcon'
import img from 'assets/img/ic-uncorrect.png'

const InCorrectIcon = (props: any) => {
  return <BaseIcon img={img} onClick={props.onClick} size={props.size} />
}

export default InCorrectIcon
